
type Props = {
  text: string;
};

const SectionDesc = ({ text }: Props) => {
  return <p className="text-[#637381] text-sm font-normal mt-1">{text}</p>;
};

export default SectionDesc;
